// Replace a.lg-btn tags in wysiwyg with the large button component
const buttonsToReplace = document.querySelectorAll('.wysiwyg a.btn, .wysiwyg a.lg-btn');

buttonsToReplace.forEach((button) => {
    // Create a new element
    const newButton = document.createElement('a');
    newButton.href = button.href;
    newButton.className = 'lg-btn tw-cursor-pointer tw-group tw-relative tw-z-10 tw-inline-flex tw-flex-wrap tw-items-center tw-text-sm tw-text-black tw-transition-colors tw-duration-300 tw-ease-in-out lg:tw-text-lg';

    newButton.innerHTML = `
        <span class="tw-absolute tw-left-0 tw-top-1/2 -tw-z-10 tw-h-[72px] tw-w-[72px] -tw-translate-y-1/2 tw-rounded-full tw-bg-brand-orange tw-transition-size tw-duration-300 tw-ease-in-out group-hover:tw-h-full group-hover:tw-w-full lg:tw-h-[108px] lg:tw-w-[108px]"></span>
        <span class="tw-flex tw-h-[72px] tw-w-[72px] tw-flex-wrap tw-items-center tw-justify-center tw-text-black lg:tw-h-[108px] lg:tw-w-[108px]">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.3335 10.332H21.333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M11.9995 19.6662L21.3326 10.3331L11.9995 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </span>
        <span class="tw-block tw-w-[calc(100%_-_72px)] tw-pl-4 tw-pr-8 lg:tw-w-[calc(100%_-_108px)]">
            ${button.textContent}
        </span>
    `;

    // Replace the old button with the new one
    button.replaceWith(newButton);
});